import { mediaDemo } from '../../../demos/media.js';

export const demoFunc = () => mediaDemo('preview');
